import { StepState, StepColorMap } from './types';

export const stepColorMap: StepColorMap = {
  [StepState.ACTIVE]: {
    initial: 'blue600',
    selected: 'blue600',
  },
  [StepState.DONE]: {
    initial: 'green600',
    selected: 'green600',
  },
  [StepState.ERROR]: {
    initial: 'red700',
    selected: 'red700',
  },
  [StepState.MODIFIED]: {
    initial: 'blue600',
    selected: 'blue600',
  },
};
